module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hero.10b6505.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/live-hr-advice/fullscreen-image_hero.png
// module id = TSdf
// module chunks = 0